"use client";

import Link from "next/link";
import { ArrowUp, Linkedin } from "lucide-react";
import SelloIncibe from "./SelloIncibe";

export default function Footer() {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer className="bg-zinc-950 text-white pt-24 pb-0 relative overflow-hidden border-t border-white/10">
            <div className="container mx-auto px-6 relative z-10">
                <div className="flex flex-col lg:flex-row justify-between items-start gap-12 lg:gap-24 mb-24">
                    {/* Left: CTA */}
                    <div className="space-y-8 max-w-sm">
                        <div className="space-y-4">
                            <h3 className="text-2xl md:text-3xl font-bold text-white font-display leading-tight">
                                Es hora de volver a ser terapeuta a tiempo completo.
                            </h3>
                            <p className="text-gray-400 font-medium">
                                Únete a los psicólogos que ya han recuperado su tiempo personal.
                            </p>
                        </div>
                        
                        {/* Logo and Social */}
                        <div className="space-y-6 pt-4">
                            <Link href="/" className="flex items-center space-x-2 grayscale">
                                <span className="text-2xl font-display font-black text-white tracking-tight">
                                    TherapyRecap
                                </span>
                            </Link>
                            <a
                                href="https://www.linkedin.com/company/therapyrecap"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                            >
                                <Linkedin size={20} />
                                <span className="text-sm font-medium">Síguenos en LinkedIn</span>
                            </a>
                        </div>
                    </div>

                    {/* Right: Links */}
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-12 lg:gap-24 text-gray-300">
                        <div className="flex flex-col gap-4">
                            <h4 className="font-bold text-white text-lg mb-2">Producto</h4>
                            <Link href="/funcionalidades" className="hover:text-white transition-colors">Características</Link>
                            <Link href="/precios" className="hover:text-white transition-colors">Precios</Link>
                            <Link href="/seguridad" className="hover:text-white transition-colors">Seguridad</Link>
                            <Link href="/ayuda" className="hover:text-white transition-colors">Centro de Ayuda</Link>
                            <Link href="/herramientas/consentimiento" className="hover:text-white transition-colors">Consentimiento</Link>
                            <Link href="/blog" className="hover:text-white transition-colors">Blog</Link>
                        </div>
                        <div className="flex flex-col gap-4">
                            <h4 className="font-bold text-white text-lg mb-2">Legal</h4>
                            <Link href="/aviso-legal" className="hover:text-white transition-colors">Aviso Legal</Link>
                            <Link href="/privacidad" className="hover:text-white transition-colors">Privacidad</Link>
                            <Link href="/terminos" className="hover:text-white transition-colors">Términos</Link>
                            <Link href="/dpa" className="hover:text-white transition-colors">DPA</Link>
                            <Link href="/posicionamiento-ai-act" className="hover:text-white transition-colors">AI Act</Link>
                            <Link href="/seguridad" className="hover:text-white transition-colors">Seguridad</Link>
                            <Link href="/cookies" className="hover:text-white transition-colors">Cookies</Link>
                            <Link href="/politica-editorial" className="hover:text-white transition-colors">Política editorial</Link>
                        </div>
                        <div className="flex flex-col gap-4 col-span-2 md:col-span-1">
                            <h4 className="font-bold text-white text-lg mb-2">Contacto</h4>
                            <p className="text-gray-300">
                                TherapyRecap S.L.<br />
                                CIF: B26767723<br />
                                Calle Sagasta 37 Ático G<br />
                                02630 La Roda (Albacete)<br />
                            </p>
                            <a href="mailto:info@therapyrecap.com" className="hover:text-white transition-colors block mt-2">
                                info@therapyrecap.com
                            </a>
                        </div>
                    </div>
                </div>

                {/* Institutional seals */}
                <div className="flex flex-col sm:flex-row items-center gap-6 border-t border-white/10 pt-8 mb-8">
                    <a
                        href="https://www.incibe.es/emprendimiento"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-surface-2 rounded-2xl p-3 shrink-0 hover:opacity-90 transition-opacity"
                    >
                        <SelloIncibe lado={80} />
                    </a>
                    <p className="text-sm text-gray-400 leading-relaxed text-center sm:text-left max-w-xl">
                        TherapyRecap ha sido finalista de <span className="text-gray-200 font-medium">INCIBE Emprende Ventures</span>, el programa de aceleración del Instituto Nacional de Ciberseguridad financiado por la Unión Europea &mdash; NextGenerationEU, dentro del Plan de Recuperación, Transformación y Resiliencia. También formamos parte del <span className="text-gray-200 font-medium">Google for Startups Cloud Program</span>.
                    </p>
                </div>

                {/* Bottom Bar */}
                <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6 border-t border-white/10 pt-8">
                    <p className="text-sm text-gray-500">
                        © 2026 TherapyRecap SL. Todos los derechos reservados.
                    </p>

                    <button
                        onClick={scrollToTop}
                        className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors group"
                        aria-label="Volver arriba"
                    >
                        <ArrowUp size={20} className="text-white group-hover:-translate-y-1 transition-transform" />
                    </button>
                </div>
            </div >

            {/* Massive Logo */}
            < div className="w-full overflow-hidden leading-none select-none pointer-events-none opacity-[0.05]" >
                {/* Decorative watermark, not a document heading. */}
                <p aria-hidden="true" className="text-[15vw] md:text-[18vw] font-black text-center text-white tracking-tighter transform -translate-y-[10%]">
                    therapyrecap
                </p>
            </div >
        </footer >
    );
}
